import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import HeaderSearch from './HeaderSearch';
import iconFavorites from '../assets/figma-home/icon-favorites.svg';
import iconCart from '../assets/figma-home/icon-cart.svg';
import { useCart } from '../context/CartContext';
import { useLanguage, LANGUAGES } from '../context/LanguageContext';
import './Header.css';

// Mesazhet e shiritit të sipërm — rrotullohen me fade çdo 3 sekonda.
// Tekstet jetojnë në src/i18n/*.js nën çelësat header.ann.*
const ANNOUNCEMENTS = [
  { icon: '📦', key: 'header.ann.shipping' },
  { icon: '📦', key: 'header.ann.guarantee' },
];

const Header = () => {
  const navigate = useNavigate();
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const { items: cartItems } = useCart();
  const { lang, setLang, t } = useLanguage();

  const [annIndex, setAnnIndex] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setAnnIndex((i) => (i + 1) % ANNOUNCEMENTS.length), 3000);
    return () => clearInterval(t);
  }, []);

  return (
    <header className="main-header">
      {/* Shiriti i sipërm me mesazh rrotullues (fade) */}
      <div className="announce-rotator">
        <span key={`${annIndex}-${lang}`} className="announce-rotator-item">
          <span className="announce-rotator-icon">{ANNOUNCEMENTS[annIndex].icon}</span>
          <span>{t(ANNOUNCEMENTS[annIndex].key)}</span>
          <span className="announce-rotator-icon">{ANNOUNCEMENTS[annIndex].icon}</span>
        </span>
      </div>

      {/* <div className="announcement-bar">
        <div className="announcement-content">
          <div className="announcement-text">
            <span className="announcement-item">
              <span className="icon">🏷️</span> Blej sigurt dhe shpejt
            </span>
            <span className="announcement-item">
              <span className="icon">📦</span> Dërgesa 100% të sigurta, kudo në Kosovë, Shqipëri dhe Maqedoni
            </span>
            <span className="announcement-item">
              <span className="icon">🏷️</span> Blej sigurt dhe shpejt
            </span>
            <span className="announcement-item">
              <span className="icon">📦</span> Dërgesa 100% të sigurta, kudo në Kosovë, Shqipëri dhe Maqedoni
            </span>
            <span className="announcement-item">
              <span className="icon">🏷️</span> Blej sigurt dhe shpejt
            </span>
            <span className="announcement-item">
              <span className="icon">📦</span> Dërgesa 100% të sigurta, kudo në Kosovë, Shqipëri dhe Maqedoni
            </span>
          </div>
        </div>
      </div> */}

      <div className="main-nav">
        <div className="nav-container">
          <button
            className="burger-btn"
            aria-label="Menu"
            onClick={() => setMobileNavOpen((open) => !open)}
          >
            ☰
          </button>

          <div className="logo" onClick={() => navigate('/')}>
            <img src={process.env.PUBLIC_URL + '/fletaime-logo.svg'} alt="Fletaime" className="logo-image" />
          </div>

          <HeaderSearch />

          <nav className="main-nav-links">
            <span className="main-nav-link active" style={{ cursor: 'pointer' }} onClick={() => navigate('/about')}>{t('header.about')}</span>
            <span className="main-nav-link active" style={{ cursor: 'pointer' }} onClick={() => navigate('/contact')}>{t('header.contact')}</span>
          </nav>

          <div className="nav-actions">
            <div className="lang-switcher">
              {LANGUAGES.map((code) => (
                <button
                  key={code}
                  className={`lang-btn ${lang === code ? 'active' : ''}`}
                  onClick={() => setLang(code)}
                >
                  {code.toUpperCase()}
                </button>
              ))}
            </div>
            <button className="icon-btn" aria-label={t('header.wishlist')} onClick={() => navigate('/te-preferuarat')}>
              <img src={iconFavorites} alt="" />
            </button>
            <button className="icon-btn cart-btn" aria-label={t('header.cart')} onClick={() => navigate('/shporta')}>
              <img src={iconCart} alt="" />
              {cartItems.length > 0 && <span className="cart-badge">{cartItems.length}</span>}
            </button>
          </div>
        </div>

        {mobileNavOpen && (
          <div className="mobile-nav-panel">
            <HeaderSearch className="mobile-search-field" onNavigate={() => setMobileNavOpen(false)} />
            <span className="mobile-nav-link" onClick={() => { setMobileNavOpen(false); navigate('/about'); }}>{t('header.about')}</span>
            <span className="mobile-nav-link" onClick={() => { setMobileNavOpen(false); navigate('/contact'); }}>{t('header.contact')}</span>
            <div className="lang-switcher mobile-lang-switcher">
              {LANGUAGES.map((code) => (
                <button
                  key={code}
                  className={`lang-btn ${lang === code ? 'active' : ''}`}
                  onClick={() => setLang(code)}
                >
                  {code.toUpperCase()}
                </button>
              ))}
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
